const determineDiscountType = (type: number): string => {
	switch (type) {
		case 1:
			return "$";

		case 2:
			return "%";

		default:
			return "$";
	}
};

export const calculateDiscount = (fee: number, promo) => {
	const discountValue = Number(promo.value);
	const discountType = determineDiscountType(promo.type);
	return discountType === "%" || discountType === "%" ? fee * (1 - discountValue / 100) : fee - discountValue;
};
